import styled from 'styled-components';
import {Panel, PanelCol, PanelContainer, Triangle} from '../Panel';
import Button from '../Button';
import PictureTriangle from '../../assets/images/triangle.svg';
import Picture from '../../assets/images/picture-03.svg';
import IconArrow from '../../assets/images/icon-arrow.svg';

type Props = {
  title: string;
  subtitle: string;
  refName?: string;
  buttonText?: string;
  allText?: string;
  onButtonClick?: () => void;
  onAllClick?: () => void;
};

const HeroArea = ({
  title,
  subtitle,
  buttonText,
  allText,
  onButtonClick,
  refName,
  onAllClick,
}: Props) => {
  return (
    <PanelContainer>
      <Panel>
        <PanelCol>
          <h1>{title}</h1>
          {refName && <h2>{refName}</h2>}
          <p>{subtitle}</p>
          {onButtonClick && (
            <Buttons>
              <Button onClick={onButtonClick}>{buttonText}</Button>
            </Buttons>
          )}
          {onAllClick && (
            <Buttons>
              <LinkToAllExperiences onClick={onAllClick}>
                <span>{allText}</span>
                <img src={IconArrow} alt="arrow" />
              </LinkToAllExperiences>
            </Buttons>
          )}
        </PanelCol>
        <PanelCol>
          <Triangle src={PictureTriangle} alt="Triangle" />
          <img src={Picture} alt="Illustration" />
        </PanelCol>
      </Panel>
    </PanelContainer>
  );
};

export default HeroArea;

const Buttons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

const LinkToAllExperiences = styled.button`
  border: none;
  background: none;
  color: ${(p) => p.theme.colors.orange500};
  text-decoration: underline;
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    margin: 0;
    display: inline-block;
    width: 24px;
    transition: all ease 100ms;
  }

  &:hover img {
    transform: translateX(10px);
  }
`;
